webpackJsonp([267660657819475],{

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _servicesModule = __webpack_require__(79);
	
	var _servicesModule2 = _interopRequireDefault(_servicesModule);
	
	var _applicationWeb = __webpack_require__(843);
	
	var _applicationWeb2 = _interopRequireDefault(_applicationWeb);
	
	var _portailIntranetExtranet = __webpack_require__(846);
	
	var _portailIntranetExtranet2 = _interopRequireDefault(_portailIntranetExtranet);
	
	var _eCommerce = __webpack_require__(844);
	
	var _eCommerce2 = _interopRequireDefault(_eCommerce);
	
	var _siteInternet = __webpack_require__(847);
	
	var _siteInternet2 = _interopRequireDefault(_siteInternet);
	
	var _iot = __webpack_require__(845);
	
	var _iot2 = _interopRequireDefault(_iot);
	
	var _applicationMobile = __webpack_require__(842);
	
	var _applicationMobile2 = _interopRequireDefault(_applicationMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Services = function (_Component) {
	    _inherits(Services, _Component);
	
	    function Services() {
	        _classCallCheck(this, Services);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Services.prototype.render = function render() {
	        var services = [{
	            title: 'Application Web',
	            subtitle: 'Développement d\'applications web',
	            image: _applicationWeb2.default,
	            description: 'Notre équipe, composée de passionnés du Web, vous accompagne dans la réalisation d\'application sur-mesure. Nous prenons en compte l\'ensemble de votre système d\'information afin d\'intégrer au mieux les apps que nous réalisons !',
	            url: '/application-web'
	        }, {
	            title: 'Portail collaboratif',
	            subtitle: ' Réalisation de portails Intranet / Extranet',
	            image: _portailIntranetExtranet2.default,
	            description: 'Les portails Web d\'entreprise ont pour objectif d\'améliorer l\'efficacité quotidienne de l\'ensemble des collaborateurs d\'une organisation. Nos équipes, fortes de plusieurs années d\'expérience dans le domaine des portails d\'entreprises, vous accompagnent et vous conseillent afin de concevoir et réaliser des sites intranet et extranet en accord avec vos besoins tout en respectant les contraintes de votre métier.',
	            url: '/portail-web-collaboratif'
	        }, {
	            title: 'Site E-commerce',
	            subtitle: ' Réalisation de site E-Commerce innovants et performants',
	            image: _eCommerce2.default,
	            description: 'Notre expérience dans la vente en ligne est très diversifiée. Nous vous accompagnons pour réaliser des sites E-Commerce B to B, les sites E-Commerce B to C, les vitrines de produits ou encore de catalogue en ligne.',
	            url: '/e-commerce'
	        }, {
	            title: 'Sites Internet',
	            subtitle: ' Nous imaginons de superbes sites vitrines à votre image',
	            image: _siteInternet2.default,
	            description: 'Parce qu\'internet évolue tous les jours, nous sommes à l\'écoute de vos besoins au quotidien, et intervenons dans les meilleurs délais afin de faire évoluer et renforcer votre présence sur les réseaux. De plus notre expérience nous permet de vous conseiller pour la mise en place de votre stratégie E-Marketing.',
	            url: '/site-internet'
	        }, {
	            title: 'Application IoT',
	            subtitle: ' Création d\'applications IoT (Objets connectés) ',
	            image: _iot2.default,
	            description: 'L\'internet des objets représente l\'extension d\'Internet à des choses et à des lieux du monde physique. Ainsi l\'IoT (Internet Of Things) permet l\'échange d\'informations provenant d\'objets physiques et réels et le réseau Internet. Integral Service de par son expertise Web ainsi que son expertise industrielle se positionne comme un acteur logique du marché de l\'IoT.',
	            url: '/application-iot'
	        }, {
	            title: 'Applications mobile',
	            subtitle: 'Des apps iOS et Android',
	            image: _applicationMobile2.default,
	            description: 'Afin de compléter notre offre de service 360°, nous proposons de vous aider dans la réalisation d\'applications mobiles sur-mesure. Que ce soit pour des environnements Apple ou Google Android, nos équipes vous accompagnent afin de réaliser l\'app que vous souhaitez !',
	            url: '/application-mobile'
	        }];
	        var servicesHmtlList = _react2.default.createElement(
	            "div",
	            null,
	            services.map(function (service, index) {
	                return _react2.default.createElement(
	                    "section",
	                    { className: _servicesModule2.default.serviceSection },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "container" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row align-items-center" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-12" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "row row-bottom-padded-md row-top-padded-md " + _servicesModule2.default.serviceContent + " " + (index % 2 ? 'flex-row-reverse' : 'flex-row') },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "col-md-4 align-self-stretch text-center" },
	                                        _react2.default.createElement("img", { src: service.image, alt: service.title, className: "text-sm-center " + _servicesModule2.default.projectimg })
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "col-md-8" },
	                                        _react2.default.createElement(
	                                            "h2",
	                                            { className: "text-center text-md-left p-0 col-12 mb-2" },
	                                            service.title
	                                        ),
	                                        _react2.default.createElement(
	                                            "h3",
	                                            { className: "text-center text-md-left p-0 col-12" },
	                                            service.subtitle
	                                        ),
	                                        _react2.default.createElement(
	                                            "p",
	                                            { className: "text-justify d-flex align-items-center" },
	                                            service.description
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "col-md-12 p-0 d-flex justify-content-md-start justify-content-center" },
	                                            _react2.default.createElement(
	                                                "a",
	                                                { href: service.url, title: 'En savoir plus sur  les ' + service.title },
	                                                _react2.default.createElement(
	                                                    "button",
	                                                    { className: "btn btn-primary" },
	                                                    "En savoir plus ! "
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            })
	        );
	
	        return _react2.default.createElement(
	            "div",
	            { className: "serviceList" },
	            servicesHmtlList
	        );
	    };
	
	    return Services;
	}(_react.Component);
	
	exports.default = Services;
	module.exports = exports["default"];

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectimg":"src-components-Page----services-module---projectimg---2BSQf","serviceSection":"src-components-Page----services-module---serviceSection---2Q28l"};

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/innovation-application-web.e6d34b48.jpg";

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Services = __webpack_require__(294);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _innovationApplicationWeb = __webpack_require__(180);
	
	var _innovationApplicationWeb2 = _interopRequireDefault(_innovationApplicationWeb);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ServicesApp = function (_Component) {
	    _inherits(ServicesApp, _Component);
	
	    function ServicesApp() {
	        _classCallCheck(this, ServicesApp);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ServicesApp.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Les services web proposés par Integral Service",
	                "description": "Notre Agence Web vous propose de vous accompagner dans tous vos projets Web et Mobile à l'aide de services complémentaires, réalisés par des experts !",
	                "cover": _innovationApplicationWeb2.default
	            }
	        };
	
	        var title = "Nos services";
	        var description = "Une équipe d'experts à votre service";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Nos services | " + _SiteConfig2.default.siteTitle,
	                description: "Notre Agence Web vous propose de vous accompagner dans tous vos projets Web et Mobile \xE0 l'aide de services compl\xE9mentaires, r\xE9alis\xE9s par des experts !"
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _innovationApplicationWeb2.default }),
	            _react2.default.createElement(_Services2.default, null),
	            _react2.default.createElement(_Contact2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return ServicesApp;
	}(_react.Component);
	
	exports.default = ServicesApp;
	
	;
	module.exports = exports["default"];

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/application-mobile.5fcd5695.jpg";

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/application-web.5d18daf3.jpg";

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/e-commerce.8d7c43fe.jpg";

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iot.4346b069.jpg";

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/portail-intranet-extranet.a210a769.jpg";

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/site-internet.2b1ccbe0.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-jsx-3fe273793d726acf92d9.js